export const logoutAction = () => {
  return {
    type: 'USER_LOGOUT'
  };
};
